import cn from 'classnames';
import React, { CSSProperties, FC, useEffect, useRef } from 'react';
import { inIframe } from 'src/utils/location';
import { notifyIframeHeight } from 'src/utils/notifyIframeHeight';
import styles from './NewPage.module.css';

export interface NewPageProps {
  children: React.ReactNode;
  className?: string;
  borders?: 'top' | 'bottom' | 'all' | 'none';
  divider?: 'top' | 'bottom' | 'none';
  style?: CSSProperties;
  flat?: boolean;
}

export const NewPage: FC<NewPageProps> = ({ children, className, borders = 'all', divider = 'none', flat, style }) => {
  const mainRef = useRef<HTMLElement>(null);
  useEffect(() => {
    const heightResizeObserver = new ResizeObserver(() => {
      notifyIframeHeight();
    });

    if (mainRef.current && inIframe({ ignoreForce: true })) {
      heightResizeObserver.observe(mainRef.current, { box: 'border-box' });
    }

    return () => {
      heightResizeObserver.disconnect();
    };
  }, []);

  return (
    <main
      ref={mainRef}
      className={cn(
        {
          [c(styles.page)]: !flat,
          [c(styles.bordersAll)]: borders === 'all',
          [c(styles.bordersTop)]: borders === 'top',
          [c(styles.bordersBottom)]: borders === 'bottom',
          [c(styles.dividerTop)]: divider === 'top',
          [c(styles.dividerBottom)]: divider === 'bottom',
        },
        className,
      )}
      style={style}
    >
      {children}
    </main>
  );
};
